import React from 'react';
import { reduce, pick, values, sum, reverse } from 'lodash';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from 'recharts';

const colors = [
  {
    active: 'rgba(217, 217, 217, 1)',
    inactive: 'rgba(217, 217, 217, 0.7)',
  },
  {
    active: 'rgba(166, 231, 120, 1)',
    inactive: 'rgba(166, 231, 120, 0.7)',
  },
  {
    active: 'rgba(40, 83, 110, 1)',
    inactive: 'rgba(40, 83, 110, 0.7)',
  },
];

export function createBarGraph(dataLabels, roundingMargin = 20000, budgetLine = false) {
  return class extends React.Component {
    state = {
      dataKeys: reduce(
        dataLabels,
        (hash, key) => {
          hash[key] = key;
          return hash;
        },
        {}
      ),
      isAnimationActive: true,
    };

    years = this.props.years;

    componentWillReceiveProps(nextProps) {
      // if (this.props !== nextProps) {
      //   if (this.props.startIndex === nextProps.startIndex) {
      //     this.setState({
      //       isAnimationActive: true,
      //     });
      //   } else {
      //     this.setState({
      //       isAnimationActive: false,
      //     });
      //   }
      // }
    }

    getData = () =>
      this.props.data.map(yr => ({
        year: yr.year,
        age: yr.age,
        'Essential Expenses': this.props.budgetLine,
        ...reduce(
          dataLabels,
          (hash, key, i) => {
            hash[key] = yr.data[i][1];
            return hash;
          },
          {}
        ),
      }));

    getMaxYDomain = () =>
      this.getData().reduce((max, curr) => {
        const currSum = Math.ceil(sum(values(pick(curr, dataLabels))) / roundingMargin) * roundingMargin;
        return Math.max(max, currSum);
      }, 0);

    handleMouseEnter = ({ dataKey }) => {
      const { dataKeys } = this.state;

      if (dataKeys[dataKey] === dataKey) {
        this.setState({
          dataKeys: { ...dataKeys, [dataKey]: dataKeys[dataKey] + ' ' },
        });
      } else {
        this.setState({
          dataKeys: { ...dataKeys, [dataKey.trim()]: dataKeys[dataKey.trim()].trim() },
        });
      }
    };

    renderCustomYTick = tickItem => {
      return `$${tickItem.toLocaleString()}/yr`;
    };

    renderTooltipLabelFormatter = label => {
      const activeYear = this.props.data.find(el => label === el.year);
      return `${label} (Age ${activeYear.age})`;
    };

    renderTooltipFormatter = value => `$${value}`;

    renderCustomizedLabel = props => {
      const { x, width, value, index } = props;
      if (index === 0 || index === this.props.data.length - 1) {
        return (
          <g>
            <text x={x + width / 2} y={310} fill="rgb(102, 102, 102)" textAnchor="middle" className="label">
              Age {value}
            </text>
          </g>
        );
      }
    };

    render() {
      const { dataKeys, isAnimationActive } = this.state;
      const { startIndex, years, budgetLine } = this.props;

      const data = this.getData();
      const visibleBars = data.slice(startIndex, startIndex + years);

      return (
        <ResponsiveContainer width="100%" aspect={4.0 / 1.75}>
          <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <XAxis
              dataKey="year"
              interval="preserveStartEnd"
              axisLine={false}
              tickLine={false}
              tickSize={10}
              tick={{ fontSize: '0.7em' }}
            />
            <YAxis
              domain={[0, this.getMaxYDomain()]}
              axisLine={false}
              tickLine={false}
              tickMargin={5}
              tick={{ fontSize: '0.7em' }}
              tickFormatter={this.renderCustomYTick}
            />
            <CartesianGrid vertical={false} />
            <Tooltip
              wrapperStyle={{
                backgroundColor: '#E0F3FF',
                stroke: '1px solid #A3DBFF',
                width: 180,
                height: 100,
                textAlign: 'center',
              }}
              itemStyle={{
                fontSize: 12,
                lineHeight: '8px',
                color: 'black',
                textAlign: 'center',
              }}
              labelStyle={{
                fontSize: 12,
                fontWeight: 1000,
              }}
              itemSorter={() => 1}
              labelFormatter={this.renderTooltipLabelFormatter}
              formatter={this.renderTooltipFormatter}
            />
            <Legend
              align="left"
              iconSize={14}
              width={500}
              wrapperStyle={{
                fontSize: 12,
                bottom: -5,
                cursor: 'pointer',
              }}
              onClick={this.handleMouseEnter}
            />
            {data &&
              reverse(dataLabels.slice()).map((label, i) => (
                <Bar
                  key={i}
                  dataKey={dataKeys[label]}
                  stackId="a"
                  fill={dataKeys[label] === label ? colors[i].active : colors[i].inactive}
                  barSize={20}
                  isAnimationActive={true}
                >
                  <LabelList dataKey="age" position="bottom" content={this.renderCustomizedLabel} />
                </Bar>
              ))}
            {budgetLine && (
              <Line
                type="monotone"
                dot={false}
                activeDot={false}
                dataKey="Essential Expenses"
                strokeWidth={2}
                stroke="#F5BA45"
              />
            )}
          </ComposedChart>
        </ResponsiveContainer>
      );
    }
  };
}
